import React, { Component } from 'react';
import Highlight from 'react-highlight';

import {
  BIG_BUTTON,
  SMALL_BUTTON
} from '../../config';
import EmbedButton from '../../components/EmbedButton/EmbedButton';
import Header from '../../components/Header/Header';
import NoLocationPlaceHolder from '../../components/NoLocationPlaceholder/NoLocationPlaceholder';
import DemoCard from '../../components/DemoCard/DemoCard';

class Tools extends Component {
  constructor(props){
    super(props);
    if(!this.props.client){
      this.props.updateClient();
    }
    this.state = {
      restaurant: null
    }
  }

  get restaurantURL(){
    try { 
      return this.props.client.locations[this.props.activeLocation]["shortURL"];
    } catch (error) {
      return null;
    }
  }

  get header(){
    return(
      <Header
        pageName="TOOLS AND EMBED"
      />
    )
  }

  /**
   * Renders placeholder component if user has not added a location yet
   */
  get noLocation(){
    return(
      <div>
        {this.header}
        <div className="pageContainer">
          <NoLocationPlaceHolder/>
        </div>
      </div>
    )
  }

  get shareableLinkandTutorials(){
    return (
      <div className="row">
        <div className="ThreebyFourcol">
          <div className="dashboardCard">
            <div className="dashboardCardBody">
              <div className="dashboardCardHeading">
                Step 3: Share!
              </div>
              <p>
                Copy and paste the following link on your restaurant's Google business page under menu and Yelp page as menu link for best results
              </p>
              <div className="getShareableLink">
                <p className="shareLink">
                    {"https://eat.app.link/" + this.restaurantURL}
                </p>
              </div>
            </div>
          </div>
        </div>
        <DemoCard/>
      </div>
    )
  }

  get openTutorial(){
     window.open("https://medium.com/@ashaya/b712f737944f");
  }
      /**
     * Renders card for Tutorial
     */
  get renderTutorial() {
    return (
        <div className="row noMargin">    
            <div className="dashboardCard">
                <div className="dashboardCardBody">
                    <p className="centered-row tutorial-help"> Any Questions? Contact us through the chat button on the bottom right of the page.</p>
                </div>
            </div>
        </div>
    )
  }

  render() {
    if(!this.props.client) return null;

    if(!this.props.client.locations || this.props.client.locations.length == 0) 
      return (this.noLocation);

    return (
      <div className="animated fadeIn">
        {this.header}
        <div className="pageContainer">
          <EmbedButton
              restaurantURL = {this.restaurantURL}
          />
          {this.shareableLinkandTutorials}
          {this.renderTutorial}
        </div>
      </div>
    )
  }
}

export default Tools;



// WEBPACK FOOTER //
// ./src/views/Tools/Tools.js